<template>

    <div>

        <!--<filters></filters>-->

        <div class="table-responsive rounded-3">
            <table class="table table-hover">
                <thead class="">
                    <tr>
                        <!--                            <th>
                                                        <input type="checkbox" class="form-check-input" value="1" @click="selectAll" v-model="allSelected">
                                                    </th>-->
                        <th scope="col" v-for="(column, columnKey) in columns" 
                            class="text-nowrap" 
                            :class="column.class"
                            :title="__(column.info)"
                            >
                            <div class="d-flex justify-content-between">
                                <div>
                                    {{ __(column.label) }}
                                    <!--@todo sort und direction an vorhandenen query-string anhängen-->
                                    <template v-if="column.sortable">
                                        <inertia-link :href="getSortableUrl(column.sortable, 'desc')" 
                                                      class="" 
                                                      :class="{'text-dark': $page.props.params.sort === column.sortable && $page.props.params.direction === 'desc'}"
                                                      preserve-state>
                                            <i class="bi bi-chevron-down"></i>
                                        </inertia-link>
                                        <inertia-link :href="getSortableUrl(column.sortable, 'asc')" 
                                                      class="" 
                                                      :class="{'text-dark': $page.props.params.sort === column.sortable && $page.props.params.direction === 'asc'}"
                                                      preserve-state>
                                            <i class="bi bi-chevron-up"></i>
                                        </inertia-link>
                                    </template>
                                </div>
                                <div></div>
                            </div>
                        </th>
                        <th></th>
                    </tr>
                    <!--                                        <tr class="table-primary">
                                                                <th>
                                                                    <input type="checkbox" class="form-check-input" value="1" @click="selectAll" v-model="allSelected">
                                                                </th>
                                                                <th scope="col" v-for="(column, columnKey) in columns" :class="column.class">
                                                                    <input type="search" class="form-control form-control-sm border-0" placeholder="Search">
                                                                </th>
                                                                <th></th>
                                                            </tr>-->
                </thead>
                <tbody>
                    <tr v-if="items.length === 0">
                        <td :colspan="Object.keys(columns).length + 1">
                            {{ __('Keine Daten verfügbar') }}
                        </td>
                    </tr>
                    <slot v-else :selected="selected" />
                </tbody>
                <!--                    <tfoot class="">
                                        <tr>
                                            <td>
                                                <input type="checkbox" class="form-check-input" value="1" @click="selectAll" v-model="allSelected">
                                            </td>
                                            <td :colspan="Object.keys(columns).length + 1">
                                                <select id="" class="form-select form-control-sm w-auto">
                                                    <option value="">Select</option>
                                                    <option value="edit">Edit</option>
                                                    <option value="delete">Delete</option>
                                                    <option value="restore">Restore</option>
                                                </select>
                                            </td>
                                        </tr>
                                    </tfoot>-->
            </table>
        </div>

        <div class="mx-3">
            <pagination :links="links" v-if="links" />
        </div>

    </div>

</template>

<script>
    import Filters from '@/shared/Admin/Filters';
    import Pagination from '@/shared/Admin/Pagination';

    export default {
        props: [
            'title',
            'columns',
            'items',
            'links',
        ],
        data() {
            return {
                selected: [],
                allSelected: false,
            };
        },
        components: {
            Filters,
            Pagination,
        },
        mounted() {
        },
        methods: {
            getSortableUrl(sort, direction)
            {
                var paramsString = window.location.search;
                var searchParams = new URLSearchParams(paramsString);
                
                searchParams.set('sort', sort);
                searchParams.set('direction', direction);
                searchParams.delete('page');
                
                return '?' + searchParams.toString();
            },
            selectAll() {
                this.selected = [];

                if (!this.allSelected) {
                    for (let item in this.items) {
                        this.selected.push(this.items[item].id);
                    }
                }
            },
        }
    }
</script>